module.exports = __webpack_public_path__ + "media/images/desktop/lets-share-title-8974d91e850198d5006e6b867e8d406a.png";